import { actionKey } from "./dashboardModel";

export type ErrorItem = { label: string; count: number };
export type ErrorDistribution = {
  source: "demo" | "analysis";
  events?: Array<{date: string; action: string; label: string; count: number}>;
  items: ErrorItem[];
  // Canonical 12-action keys. Absent means unavailable, [] means no observed errors.
  byAction?: Record<string, ErrorItem[]>;
};
export function sumErrorItems(groups: ErrorItem[][]): ErrorItem[] {
  const counts = new Map<string, number>();
  groups.flat().forEach(item => { if (Number.isFinite(item.count) && item.count > 0) counts.set(item.label, (counts.get(item.label) ?? 0) + item.count); });
  return [...counts].map(([label, count]) => ({ label, count })).sort((a, b) => b.count - a.count || a.label.localeCompare(b.label));
}
export function errorItemsForAction(data: ErrorDistribution, action: string, days = 0): ErrorItem[] | undefined {
  if (data.events) return sumErrorItems([data.events.filter(event => (action === "all" || actionKey(event.action) === action) && (!days || event.date >= distributionStartDate(days)))]);
  if (days) return undefined;
  const items = action === "all" ? data.items : data.byAction?.[action];
  return items === undefined ? undefined : sumErrorItems([items]);
}

export function distributionStartDate(days: number, now = Date.now()): string { return new Date(now + 8 * 3600000 - (days - 1) * 86400000).toISOString().slice(0, 10); }
